module.exports = __webpack_public_path__ + "3dfb7023f854b2b8ed0be9b63a78f9cf.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/TWS.jpg
// module id = 623
// module chunks = 0